import { createRoot } from "react-dom/client"; // ✅ Note this change
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./store";

const container = document.getElementById("root");
const root = createRoot(container); // ✅ New root creation
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
